import gql from "graphql-tag";

import { metadataFragment } from "./metadata";

export const categoryFragment = gql`
  fragment CategoryFragment on Category {
    id
    name
    children {
      totalCount
    }
    level
    products {
      totalCount
    }
    storeType
    smMarketsId
    isFeatured
  }
`;
export const categoryDetailsFragment = gql`
  ${metadataFragment}
  fragment CategoryDetailsFragment on Category {
    id
    ...MetadataFragment
    backgroundImage {
      alt
      url
    }
    name
    slug
    descriptionJson
    seoDescription
    seoTitle
    storeType
    parent {
      id
      name
    }
    iconImage {
      alt
      url
    }
    color
    smMarketsId
    isFeatured
  }
`;

export const categoryCodeFragment = gql`
  fragment CategoryCodeFragment on Category {
    id
    name
    code
    parent {
      id
      name
      code
    }
  }
`;
